var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { ImportVisitFollowRecordCaseService } from "~/services/dataimp-service/import-visit-follow-record-case.service";
var DeleteFollowRecord = /** @class */ (function (_super) {
    __extends(DeleteFollowRecord, _super);
    function DeleteFollowRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.importModel = {
            fileId: '',
        };
        _this.importRules = {
            fileId: { required: true, message: '请上传文件' },
        };
        _this.mfileList = [];
        return _this;
    }
    DeleteFollowRecord.prototype.close = function () {
        this.reset();
    };
    DeleteFollowRecord.prototype.success = function () {
        this.$message.success("操作成功");
        this.close();
    };
    Object.defineProperty(DeleteFollowRecord.prototype, "fileList", {
        get: function () {
            return this.mfileList;
        },
        set: function (val) {
            this.mfileList = val;
            this.importModel.fileId = val.length && val[0].response ? val[0].response.id : "";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 表单重置
     */
    DeleteFollowRecord.prototype.reset = function () {
        var upload = this.$refs['upload_case_import'];
        upload.reset();
        var form = this.$refs['form'];
        form.resetFields();
    };
    /**
     * 表单提交
     */
    DeleteFollowRecord.prototype.submit = function () {
        var _this = this;
        var form = this.$refs['form'];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.importVisitFollowRecord
                .importDeleteCollection(_this.importModel)
                .subscribe(_this.success);
        });
    };
    __decorate([
        Dependencies(ImportVisitFollowRecordCaseService)
    ], DeleteFollowRecord.prototype, "importVisitFollowRecord", void 0);
    __decorate([
        Emit('close')
    ], DeleteFollowRecord.prototype, "close", null);
    __decorate([
        Emit('success')
    ], DeleteFollowRecord.prototype, "success", null);
    DeleteFollowRecord = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], DeleteFollowRecord);
    return DeleteFollowRecord;
}(Vue));
export default DeleteFollowRecord;
